<script>
import { notifications } from '~/app/notifications'

export default {
  methods: {
    async nextStep() {
      if (this.$store.state.globals.cartConfiguration.shopping_disabled) {
        notifications.warning(this.$store.state.globals.cartConfiguration.shopping_disabled_text)
        return
      }
      if (
        typeof this.$store.state.globals.orderMinimumValue === 'number' &&
        this.$store.state.globals.orderMinimumValue > this.$store.state.cart.cartData?.prices?.totalWithTax
      ) {
        notifications.danger(
          this.$t('globals.cart.orderMinimumValue.error', {
            remainingPrice: this.$currencyFormat(
              this.$store.state.globals.orderMinimumValue - this.$store.state.cart.cartData.prices.totalWithTax,
            ),
          }),
        )
        return
      }
      if (this.$themeSettings.checkout.enableCartDataValidation) {
        const validationResponse = await this.$store.dispatch('cart/VALIDATE_CART_DATA')
        if (!validationResponse) {
          return
        }
      }
      this.$store.commit('cart/SET_CHECKOUT_STEP', this.$store.state.cart.checkout.currentStep + 1)
      this.redirectToCurrentStep()
    },
    previousStep() {
      this.$store.commit('cart/SET_CHECKOUT_STEP', this.$store.state.cart.checkout.currentStep - 1)
      this.redirectToCurrentStep()
    },
    goToStep(step) {
      if (step === this.$store.state.cart.checkout.currentStep + 1) {
        this.$emit('nextStep')
      } else if (step < this.$store.state.cart.checkout.currentStep) {
        this.$store.commit('cart/SET_CHECKOUT_STEP', step)
        this.redirectToCurrentStep()
      }
    },
    redirectToCurrentStep() {
      if (this.$store.state.cart.checkout.steps[this.$store.state.cart.checkout.currentStep]) {
        this.$router.push(
          this.localePath({
            name: this.$store.state.cart.checkout.steps[this.$store.state.cart.checkout.currentStep].path,
          }),
        )
      }
    },
  },
}
</script>
